/* Native details + submit buttons keep currency switching usable without JS. */
if (!customElements.get('currency-picker')) {
  customElements.define('currency-picker', class extends HTMLElement {
    #controller;

    connectedCallback() {
      this.#controller?.abort();
      this.#controller = new AbortController();
      const { signal } = this.#controller;
      const details = this.querySelector('details');
      const summary = this.querySelector('summary');
      if (!details || !summary) return;

      document.addEventListener('pointerdown', (event) => {
        if (!this.contains(event.target)) details.open = false;
      }, { signal });
      document.addEventListener('focusin', (event) => {
        if (!this.contains(event.target)) details.open = false;
      }, { signal });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && details.open) {
          event.preventDefault();
          details.open = false;
          summary.focus();
        }
        if (event.key === 'ArrowDown' && event.target === summary) {
          event.preventDefault();
          details.open = true;
          this.querySelector('button:not(:disabled)')?.focus();
        }
      }, { signal });
    }

    disconnectedCallback() {
      this.#controller?.abort();
    }
  });
}
